export enum FontSize {
	XXS = '11px',
	XS = '12px',
	S = '13px',
	MD = '14px',
	BASE = '16px',
	LG = '20px',
	XL = '24px',
	XXL = '28px',
	XXXL = '34px',
	XXXXL = '40px',
	XXXXXL = '58px'
}

export enum FontWeight {
	LIGHT = 300,
	REGULAR = 400,
	MEDIUM = 500,
	SEMI_BOLD = 600,
	BOLD = 700
}
